import React from "react";
import { StatusIndicator } from "@amzn/awsui-components-react";
import { STATUS_INDICATOR } from "./investigationUtils";
import { DocumentRedrive, statusLabel } from "./documentRedrive";
import { READY_TO_RESOLVE, READY_TO_RESOLVE_LABEL } from "./readyToResolve";

interface InvestigationStatusChipProps {
  status?: string | null;
  /** Shows "Ready to redrive (DLQ)" / "Order redrive running" on the document-redrive path. */
  documentRedrive?: DocumentRedrive;
  /** False keeps the chip on one line (table cells). */
  wrapText?: boolean;
  /** CR a BLOCKED case waits on (see waitingOnCodeReview): shown as "Waiting for CR-X". */
  waitingOn?: string | null;
}

export const InvestigationStatusChip: React.FC<
  InvestigationStatusChipProps
> = ({ status, documentRedrive, wrapText, waitingOn }) => {
  if (!status)
    return (
      <StatusIndicator type="info" wrapText={wrapText}>
        Unknown
      </StatusIndicator>
    );
  if (status === READY_TO_RESOLVE)
    return (
      <StatusIndicator type="success" wrapText={wrapText}>
        {READY_TO_RESOLVE_LABEL}
      </StatusIndicator>
    );
  return (
    <StatusIndicator
      type={
        status === "BLOCKED" && waitingOn
          ? "pending"
          : STATUS_INDICATOR[status] || "info"
      }
      wrapText={wrapText}
    >
      {status === "BLOCKED" && waitingOn
        ? `Waiting for ${waitingOn}`
        : statusLabel(status, documentRedrive)}
    </StatusIndicator>
  );
};

export default InvestigationStatusChip;
